import { render, staticRenderFns } from "./index.vue?vue&type=template&id=330505e4"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\privateItem\\sct-shop\\sct-shop-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('330505e4')) {
      api.createRecord('330505e4', component.options)
    } else {
      api.reload('330505e4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=330505e4", function () {
      api.rerender('330505e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appSetting/wxAccount/reply/index.vue"
export default component.exports